import React from "react";
import CustodyOrder from "../../../components/documents/custodyOder/CustodyOrder";

const CustodyOrderPage = () => {
  return <CustodyOrder />;
};

export default CustodyOrderPage;
